export default __webpack_public_path__ + "static/ksenia-b6f637c7e3b100119559abe863118dc9.jpg";